var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { msg, localized } from "@lit/localize";
let KpiCard = class KpiCard extends LitElement {
    constructor() {
        super(...arguments);
        this.detail = null;
    }
    render() {
        return html `
            <div class="card">
                <div class="content">
                    <div class="value">${this.value}</div>
                    ${this.icon
            ? html `<img src="${this.icon}" alt=${msg("Icon", { id: "card.icon.alt", desc: "Alt text for a card's icon image" })} class="icon" />`
            : null}
                </div>
                <div class="label">${this.label}</div>
                ${this.evolution !== undefined
            ? html `
                          <div
                              class="evolution ${this.evolution >= 0
                ? "positive"
                : "negative"}"
                          >
                              ${this.evolution >= 0 ? "▲" : "▼"}
                              ${Math.abs(this.evolution)}%
                          </div>
                      `
            : null}
                ${this.detail
            ? html `<div class="detail"><p>${this.detail}</p></div>`
            : null}
            </div>
        `;
    }
};
KpiCard.styles = css `
        :host {
            display: block;
            font-family: inherit;
            position: relative;
        }

        .card {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            position: relative;
            padding: 1rem;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
        }

        .card:hover {
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        }

        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }

        .icon {
            font-size: 2rem;
            margin-left: 0.5rem;
            color: var(--icon-color, #555);
        }

        .value {
            font-size: 1.5rem;
            font-weight: bold;
            color: var(--value-color, #333);
        }

        .label {
            font-size: 0.9rem;
            color: var(--label-color, #777);
            margin-top: 0.25rem;
        }

        .evolution {
            margin-top: 0.5rem;
            font-size: 0.85rem;
            font-weight: bold;
            color: var(--evolution-color, #333);
        }

        .evolution.positive {
            color: #4caf50; /* Green for positive evolution */
        }

        .evolution.negative {
            color: #f44336; /* Red for negative evolution */
        }

        img {
            width: 32px;
            height: 32px;
        }

        .detail {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%; /* Utilise toute la largeur de la carte */
            height: 100%; /* Utilise toute la hauteur de la carte */
            background: rgba(255, 255, 255, 0.95);
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding: 2rem; /* Ajout d'un padding interne pour espacer le contenu */
            font-size: 0.9rem;
            color: #333;
            opacity: 0;
            visibility: hidden;
            transform: translate(-50%, -50%) scale(0.95);
            transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
            z-index: 10;
            border-radius: 8px; /* Ajout d'un arrondi pour un style moderne */
            box-sizing: border-box; /* Inclut le padding dans la largeur totale */
        }

        .card:hover .detail {
            opacity: 1;
            visibility: visible;
            transform: translate(-50%, -50%) scale(1);
        }
    `;
__decorate([
    property({ type: String })
], KpiCard.prototype, "label", void 0);
__decorate([
    property({ type: String })
], KpiCard.prototype, "value", void 0);
__decorate([
    property({ type: String })
], KpiCard.prototype, "icon", void 0);
__decorate([
    property({ type: Number })
], KpiCard.prototype, "evolution", void 0);
__decorate([
    property({ type: String })
], KpiCard.prototype, "detail", void 0);
KpiCard = __decorate([
    localized(),
    customElement("kpi-card")
], KpiCard);
export { KpiCard };
//# sourceMappingURL=KpiCard.js.map